<nb-layout windowMode>
  <nb-layout-column>
    <nb-card>
      <nb-card-header class="register-card-header">
        <a routerLink="/">
          <button nbButton ghost>
            <nb-icon status="primary" icon="arrow-back"></nb-icon>
          </button>
        </a>
      </nb-card-header>
      <nb-card-body class="register-card-body" style="padding: 0">
        <div class="wrapper">
          <div class="register-page">
            <h1>Registrar-se</h1>
            <p>Seja um lojista agora mesmo! Preencha os campos abaixo.</p>
            <form
              id="registerForm"
              [formGroup]="registerForm"
              (submit)="onRegisterFormSubmit()"
            >
              <div class="row">
                <div class="col-6">
                  <label>Razão Social</label>
                  <input
                    nbInput
                    [nbPopover]="razaoSocialError"
                    fullWidth
                    formControlName="razaoSocial"
                    [class]="{ 'invalid': isInvalid('razaoSocial') }"
                  />
                  <ng-template #razaoSocialError>
                    <span class="error">{{
                      getErrorMessage("razaoSocial")
                    }}</span>
                  </ng-template>
                </div>
                <div class="col-6">
                  <label>Nome de Fantasia</label>
                  <input
                    nbInput
                    [nbPopover]="nomeFantasiaError"
                    fullWidth
                    formControlName="nomeFantasia"
                    [class]="{ 'invalid': isInvalid('nomeFantasia') }"
                  />
                  <ng-template #nomeFantasiaError>
                    <span class="error">{{
                      getErrorMessage("nomeFantasia")
                    }}</span>
                  </ng-template>
                </div>
                
                </div>
                <div class="row">
                  <div class="col-4">
                    <label>Inscrição Estadual</label>
                    <input
                    nbInput
                    fullWidth
                    formControlName="inscricaoEstadual"
                    [nbPopover]="inscricaoEstadualError"
                    [class]="{ 'invalid': isInvalid('inscricaoEstadual') }"
                    />
                    <ng-template #inscricaoEstadualError>
                      <span class="error">{{
                        getErrorMessage("inscricaoEstadual")
                      }}</span>
                    </ng-template>
                  </div>
                  <div class="col-4">
                    <label>CPF</label>
                    <input
                      nbInput fullWidth
                      formControlName="cpf"
                      [imask]="{ mask: '000.000.000-00' }"
                      [nbPopover]="cpfError"
                      [class]="{ 'invalid': isInvalid('cpf') }"
                    />
                    <ng-template #cpfError>
                      <span class="error">{{
                        getErrorMessage("cpf")
                      }}</span>
                    </ng-template>
                  </div>
                  <div class="col-4">
                    <label>CNPJ</label>
                    <input
                      nbInput
                      fullWidth
                      formControlName="cnpj"
                      [imask]="{ mask: '00.000.000/0000-00' }"
                      [nbPopover]="cnpjError"
                      [class]="{ 'invalid': isInvalid('cnpj') }"
                      />
                      <ng-template #cnpjError>
                        <span class="error">{{ getErrorMessage("cnpj") }}</span>
                      </ng-template>
                    </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <label>E-mail</label>
                    <input
                    nbInput
                    fullWidth
                    type="email"
                    formControlName="email"
                    [nbPopover]="emailError"
                    [class]="{ 'invalid': isInvalid('email') }"
                    />
                    <ng-template #emailError>
                      <span class="error">{{ getErrorMessage("email") }}</span>
                    </ng-template>
                  </div>
                  <div class="col-4">
                    <label>Senha</label>
                    <input
                    nbInput
                    fullWidth
                    type="password"
                    formControlName="senha"
                    [nbPopover]="senhaError"
                    [class]="{ 'invalid': isInvalid('senha') }"
                    />
                    <ng-template #senhaError>
                      <span class="error">{{ getErrorMessage("senha") }}</span>
                    </ng-template>
                  </div>
                  <div class="col-4">
                    <label>Confirmar Senha</label>
                    <input
                    nbInput
                    fullWidth
                    type="password"
                    formControlName="senha2"
                    [nbPopover]="senha2Error"
                    [class]="{ 'invalid': isInvalid('senha2') }"
                    />
                    <ng-template #senha2Error>
                      <span class="error">{{ getErrorMessage("senha2") }}</span>
                    </ng-template>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <label>CEP</label>
                    <input
                      nbInput fullWidth
                      formControlName="cep"
                      [nbPopover]="cepError"
                      [imask]="{ mask: '00000-000' }"
                      (change)="fillAddresses()"
                      (blur)="fillAddresses()"
                    />
                    <ng-template #cepError>
                      <span class="error">{{
                        getErrorMessage("cep")
                      }}</span>
                    </ng-template>
                  </div>
                  <div class="col-5">
                    <label>Logradouro</label>
                    <input
                    nbInput
                    fullWidth
                    formControlName="logradouro"
                    [nbPopover]="logradouroError"
                    [class]="{ 'invalid': isInvalid('logradouro') }"
                    />
                    <ng-template #logradouroError>
                      <span class="error">{{
                        getErrorMessage("logradouro")
                      }}</span>
                    </ng-template>
                  </div>
                  <div class="col-4">
                    <label>Bairro</label>
                    <input
                      nbInput fullWidth
                      [nbPopover]="bairroError"
                      formControlName="bairro"
                    />
                    <ng-template #bairroError>
                      <span class="error">{{
                        getErrorMessage("bairro")
                      }}</span>
                    </ng-template>
                  </div>
                </div>
                <div class="row">
                  <div class="col-2">
                    <label>UF</label>
                    <nb-select fullWidth formControlName="uf" (selectedChange)="onUFChange($event)">
                      <nb-option *ngFor="let uf of ufs" [value]="uf.id">{{ uf.sigla }}</nb-option>
                    </nb-select>
                  </div>
                  <div class="col-4">
                    <label>Município</label>
                    <input 
                      #autoInput 
                      nbInput 
                      type="text" 
                      (input)="onMunicipioInputChange()"
                      [nbAutocomplete]="auto"
                      fullWidth
                      formControlName="municipio"
                      class="municipio"
                    />
                    <nb-autocomplete [activeFirst]="false" #auto (selectedChange)="onSelectionChange($event)">
                      <nb-option *ngFor="let municipio of municipiosSuggestions" [value]="municipio">
                        {{ municipio }}
                      </nb-option>
                    </nb-autocomplete>
                    <!-- <nb-select #municipioSelect fullWidth formControlName="municipio" [disabled]="municipios.length === 0">
                      <nb-option *ngFor="let municipio of municipios" [value]="municipio.id">{{ municipio.nome }}</nb-option>
                    </nb-select> -->
                  </div>
                  <div class="col-6">
                    <label>Complemento</label>
                    <input 
                      nbInput fullWidth
                      formControlName="pontoReferencia"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <label>Celular</label>
                    <input
                      nbInput
                      fullWidth
                      formControlName="celular"
                      [imask]="{ mask: '(00) 00000-0000' }"
                      [nbPopover]="celularError"
                      [class]="{ 'invalid': isInvalid('celular') }"
                    />
                    <ng-template #celularError>
                      <span class="error">{{ getErrorMessage("celular") }}</span>
                    </ng-template>
                  </div>
                  <div class="col-3">
                    <label>Telefone</label>
                    <input
                      nbInput
                      fullWidth
                      formControlName="telefone"
                      [imask]="{ mask: '(00) 0000-0000' }"
                      [nbPopover]="telefoneError"
                      [class]="{ 'invalid': isInvalid('telefone') }"
                    />
                    <ng-template #telefoneError>
                      <span class="error">{{ getErrorMessage("telefone") }}</span>
                    </ng-template>
                  </div>
                  <div class="col-3"></div>
                  <div class="col-3" style="display: flex; flex-direction: column; justify-content: flex-end;">
                    <button
                      nbButton
                      type="submit"
                      status="primary"
                      form="registerForm"
                      [disabled]="registerForm.invalid"
                      fullWidth
                    >
                      Registrar
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="illustration"></div>
          </div>
        </nb-card-body>
      </nb-card>
    </nb-layout-column>
  </nb-layout>
  